var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.activePayload ? _c('div', {
    staticClass: "asset-viewer"
  }, [_c('div', {
    staticClass: "asset-viewer__bg touch",
    on: {
      "click": _vm.close
    }
  }), _c('transition', {
    attrs: {
      "name": "asset-viewer-content"
    }
  }, [_c('div', {
    staticClass: "asset-viewer__content"
  }, [_c('div', {
    staticClass: "asset-viewer__header"
  }, [_c('div', {
    staticClass: "asset-viewer__close touch",
    on: {
      "click": _vm.close
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fal', 'times']
    }
  })], 1), _vm.tagLabel ? _c('div', {
    staticClass: "asset-viewer__label",
    domProps: {
      "innerHTML": _vm._s(_vm.tagLabel)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "asset-viewer__wrapper touch",
    class: {
      'asset-viewer__wrapper--expand': _vm.expanded
    }
  }, [_vm.hasMultiplePayloads ? _c('div', {
    staticClass: "asset-viewer__index"
  }, [_vm._v(_vm._s(_vm.payloadIndex + 1) + " / " + _vm._s(_vm.payloadX.length))]) : _vm._e(), _vm.tag && _vm.tag.icon ? _c('div', {
    staticClass: "asset-viewer__icon",
    style: _vm.iconStyles
  }, [_c('fa', {
    attrs: {
      "icon": ['fas', _vm.tag.icon],
      "fixed-width": ""
    }
  })], 1) : _vm._e(), _vm.hasMultiplePayloads ? _c('div', {
    staticClass: "asset-viewer__left touch",
    on: {
      "click": _vm.indexDown
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fal', 'chevron-left']
    }
  })], 1) : _vm._e(), _vm.hasMultiplePayloads ? _c('div', {
    staticClass: "asset-viewer__right touch",
    on: {
      "click": _vm.indexUp
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fal', 'chevron-right']
    }
  })], 1) : _vm._e(), _vm.payloadX.length > 1 ? _c('div', {
    staticClass: "asset-viewer__dots"
  }, _vm._l(_vm.payloadX, function (payload, index) {
    return _c('button', {
      key: "asset-dot-".concat(index),
      staticClass: "asset-viewer__dot touch",
      class: {
        'asset-viewer__dot--active': _vm.payloadIndex === index
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          _vm.payloadIndex = index;
        }
      }
    });
  }), 0) : _vm._e(), _c('transition', {
    attrs: {
      "name": _vm.slideTransition,
      "mode": "out-in"
    }
  }, [_c('div', {
    key: _vm.activePayload,
    staticClass: "asset touch",
    on: {
      "click": _vm.openVirtualTour,
      "touchstart": _vm.handleTouchStart,
      "touchmove": _vm.handleTouchMove,
      "touchend": _vm.handleTouchEnd
    }
  }, [_vm.payloadType === 'video' ? [_vm.status === 'stopped' || _vm.status === 'paused' ? _c('div', {
    staticClass: "pause-icon touch",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.play.apply(null, arguments);
      }
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fas', 'play']
    }
  })], 1) : _vm._e(), _vm.status === 'playing' ? _c('div', {
    staticClass: "pause-icon touch",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.pause.apply(null, arguments);
      }
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fal', 'pause']
    }
  })], 1) : _vm._e(), _c('video', {
    key: _vm.activePayload,
    ref: "video",
    style: _vm.style,
    attrs: {
      "src": _vm.activePayload,
      "autoplay": "",
      "loop": "",
      "playsinline": "",
      "disablePictureInPicture": "",
      "poster": "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
    },
    on: {
      "play": _vm.onPlay,
      "timeupdate": _vm.progress
    }
  }), _vm.playbackProgress > 0 ? _c('div', {
    staticClass: "asset-viewer__progress",
    class: {
      'asset-viewer__progress--playing': _vm.status === 'playing'
    }
  }, [_c('div', {
    staticClass: "progress-bar",
    style: "width: ".concat(_vm.playbackProgress, "%")
  })]) : _vm._e()] : _vm.payloadType === 'image' ? [_c('img', {
    style: _vm.style,
    attrs: {
      "src": _vm.activePayload,
      "alt": ""
    }
  })] : _vm._e()], 2)])], 1)])])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }